module.exports = "/_next/static/images/party_popper-f25dad74018a2c9808de182a09589f6f.png";